<template>
    <div class="background">
        <div class="input">
            <van-field v-model="phone" type="number" placeholder="请输入手机号" input-align="center" class="inputField"/>
            <van-row>
                <van-col span="12">
                    <van-button round size="small" @click="confirmRecharge" class="buyButton">点击去购买</van-button>
                </van-col>
                <van-col span="12">
                    <van-button round size="small" :url="'https://m.black-unique.com/activate'" class="buyButton">激活骑士卡</van-button>
                </van-col>
            </van-row>
            <van-row style="color:white;font-size:1.5rem;margin-top:2.5rem;">
                该活动仅限白条新用户参与，如客户为白条老用户，支付款项次日将原路退回<br/>
                客服电话：0571-89936492
            </van-row>
        </div>
    </div>
</template>

<script>
    import jdPayAPI from '@/api/jdPay';
    import pvuvAPI from '@/api/pvuv';

    export default {
        data() {
            return {
                query: {
                    traderId: this.$route.query.traderId,
                    pid: this.$route.query.pid,
                },
                phone: '',
            }
        },
        methods: {
            confirmRecharge() {
                if (!this.$myUtil.mobile(this.phone)) {
                    this.$toast("请输入正确的手机号");
                    return;
                }
                this.$toast("正在跳转支付...");
                jdPayAPI.qishi(this.query.traderId, this.phone, this.query.pid).then((result) => {
                    window.location.href = result.data;
                }).catch(() => {
                });
            },
        },
        created() {
        },
        mounted() {
            pvuvAPI.addPv("qishiJdPay/index", this.query.traderId).then((result) => {
            });
        }
    }

</script>

<style lang="scss" scoped>
    .background {
        background-image: url('http://jho2o.oss-cn-beijing.aliyuncs.com/test/2NkiHaLT.jpg');
        background-size: 100% 100%;
        height: 75rem;
        padding-top: 28rem;
        text-align: center;
    }

    .input {
        margin: 0 auto;
        width: 85%;
    }

    .inputField {
        height: 4rem;
        border-radius: 2rem;
        font-size: 1.8rem;
    }

    .buyButton {
        margin-top: 1.5rem;
        height: 4rem;
        width: 11.5rem;
        background-image: url("http://jho2o.oss-cn-beijing.aliyuncs.com/test/2NoSyGG1.png");
        background-size: 100% 100%;
        font-size: 2rem;
        font-weight: bold;
        color: #FFFFFF;
    }

</style>
